import { useId, useState } from 'react';

/**
 * 설명 툴팁.
 *
 * ★★ **긴 설명을 화면에서 치운다**(2026-10-03, 사용자 지시 — 「텍스트가 많아서
 * 보기 힘들다」). ⚠️ **지우는 것이 아니다** — 이 프로젝트의 설명문은 대부분
 * 「왜 이렇게 세는가」라서 **없으면 숫자를 오해한다.** 숨기되 한 번에 꺼낸다.
 *
 * ⚠️ 이모지를 쓰지 않는다 — SUIT 에 없어 폴백 폰트로 깨진다. 글리프는 SVG 다.
 * ★ 키보드로도 열린다(`button` + `aria-expanded`). 호버만으로 만들면
 *   키보드·터치에서 **읽을 방법이 없어진다.**
 */
export function Info({ text, label = '설명' }: { text: string; label?: string }) {
  const [open, setOpen] = useState(false);
  const id = useId();
  if (text === '') return null;
  return (
    <span className="relative inline-flex align-middle">
      <button
        type="button"
        aria-label={label}
        aria-expanded={open}
        aria-controls={id}
        onClick={() => setOpen((v) => !v)}
        onMouseEnter={() => setOpen(true)}
        onMouseLeave={() => setOpen(false)}
        onBlur={() => setOpen(false)}
        className="grid h-6 w-6 place-items-center rounded-pill border border-border text-muted-foreground transition-colors hover:border-primary hover:text-primary"
      >
        <svg viewBox="0 0 16 16" className="h-3.5 w-3.5" aria-hidden="true">
          <circle cx="8" cy="4" r="1.1" fill="currentColor" />
          <rect x="7.1" y="6.5" width="1.8" height="6" rx="0.9" fill="currentColor" />
        </svg>
      </button>
      {open ? (
        <span
          id={id}
          role="tooltip"
          className="absolute top-8 left-0 z-20 w-[min(34rem,70vw)] rounded-md border border-border bg-popover p-lg text-body-sm leading-relaxed text-muted-foreground shadow-popover"
        >
          {text}
        </span>
      ) : null}
    </span>
  );
}
